import { TrophyType } from '../services/TournamentService';

export const ShirtIcon = ({ color = '#3498db', number = '12' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    stroke="black"
    strokeWidth="1"
    height="100px"
    width="100px"
    version="1.1"
    viewBox="0 0 295.526 295.526"
    style={{ display: 'flex' }}
  >
    <g>
      <path
        d="M147.763,44.074c12.801,0,23.858-8.162,27.83-20.169c-7.578,2.086-17.237,3.345-27.83,3.345   
          c-10.592,0-20.251-1.259-27.828-3.345C123.905,35.911,134.961,44.074,147.763,44.074z"
      />
      <path
        d="M295.158,58.839c-0.608-1.706-1.873-3.109-3.521-3.873l-56.343-26.01c-11.985-4.06-24.195-7.267-36.524-9.611   
          c-0.434-0.085-0.866-0.126-1.292-0.126c-3.052,0-5.785,2.107-6.465,5.197c-4.502,19.82-22.047,34.659-43.251,34.659   
          c-21.203,0-38.749-14.838-43.25-34.659c-0.688-3.09-3.416-5.197-6.466-5.197c-0.426,0-0.858,0.041-1.292,0.126   
          c-12.328,2.344-24.538,5.551-36.542,9.611L3.889,54.965c-1.658,0.764-2.932,2.167-3.511,3.873   
          c-0.599,1.726-0.491,3.589,0.353,5.217l24.46,48.272c1.145,2.291,3.474,3.666,5.938,3.666c0.636,0,1.281-0.092,1.917-0.283   
          l27.167-8.052v161.97c0,3.678,3.001,6.678,6.689,6.678h161.723c3.678,0,6.67-3.001,6.67-6.678V107.66l27.186,8.052   
          c0.636,0.191,1.28,0.283,1.915,0.283c2.459,0,4.779-1.375,5.94-3.666l24.469-48.272C295.629,62.428,295.747,60.565,295.158,58.839z"
      />
    </g>

    <text x="147" y="150" fontFamily="Arial" fontSize="60" textAnchor="middle" fill="white">
      {number}
    </text>
  </svg>
);

export const ShortsIcon = ({ color = '#3498db' }) => (
  <svg
    fill={color}
    stroke="black"
    strokeWidth="1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 461.217 461.217"
    xmlSpace="preserve"
    width="90px"
    height="90px"
    style={{ display: 'flex', paddingLeft: '5px' }}
  >
    <g>
      <path d="M258.71,86.032c-9.053,1.162-17.581,1.956-27.243,2.128l-0.479,0.832c-0.038,0.223-3.454,20.434,7.051,28.427 c4.188-6.785,8.127-12.351,10.957-15.475C255.849,94.378,258.71,86.032,258.71,86.032z"></path>
      <path d="M225.392,173.406c6.672-0.862,14.502-12.906,16.727-26.108c0.966-5.685,0.913-12.125-1.351-16.172 C231.077,148.896,222.979,169.292,225.392,173.406z"></path>
      <path d="M351.213,78.286l-2.829-18.35c0,0-36.969,18.568-85.871,25.593c0.918,0.88,1.724,2.036,2.16,3.524 c1.442,4.917-1.339,11.009-8.74,19.18c-3.134,3.462-6.645,8.458-10.135,14.176c5.458,5.354,7.53,14.784,5.55,26.449 c-2.62,15.504-12.354,32.524-25.216,33.544c-0.331,0.034-0.643,0.05-0.958,0.05c-3.693,0-6.645-1.768-8.204-4.929 c-4.539-9.257,5.573-33.043,16.272-51.986c-14.907-10.151-12.246-33.1-11.581-37.474c-60.077-1.583-111.645-28.116-111.645-28.116 l-5.646,21.147c0,0-43.717,77.576-64.876,131.171C18.346,265.869,0,340.632,0,340.632s74.751,57.812,214.386,60.648l15.528-87.466 l28.207,87.458c0,0,126.938-21.135,203.096-64.888c0,0-36.66-108.582-46.542-139.623 C404.801,165.72,370.954,98.039,351.213,78.286z M86.637,351.978l-11.99-3.286l11.55-42.006l-0.157-0.045l-11.445,2.049 l0.509-9.854l15.896-2.665l10.193,2.805L86.637,351.978z M150.994,329.5c-2.473,8.964-10.78,14.314-20.406,19.031l-6.009,2.74 l-0.05,0.141l20.059,5.526l-2.803,10.203l-37.588-10.331l2.058-7.498l8.438-4.256c14.525-7.238,21.784-11.646,23.582-17.842 c1.196-4.308-0.407-8.415-6.512-10.118c-4.562-1.242-9.197-0.061-12.531,1.21l-1.084-9.75c4.74-1.947,11.689-2.677,18.785-0.729 C149.015,311.161,153.607,319.941,150.994,329.5z"></path>
    </g>
  </svg>
);

export const getTrophyEmoji = (type: TrophyType) => {
  switch (type) {
    case TrophyType.Shooter:
      return '⚽️';
    case TrophyType.Goalkeeper:
      return '🧤';
    case TrophyType.MVP:
      return '⭐️';
    default:
      return '👍';
  }
};
